angular.module('bb.appointments').directive('apptUsersWatching', () => {
  return {
    restrict: 'E',
    scope: {},
    controller: 'ApptWatch',
    controllerAs: 'vm',
    bindToController: true,
    template: `
            <div>
                <h4 ng-if="vm.usersViewing.length">
                    Other users looking at this showing -
                    <span>{{vm.usersViewingString}}</span>
                </h4>
                <h6 ng-if="vm.youAreViewing()">
                    You have this open in another tab
                </h6>
            </div>`,
  };
});
